$(function () {

});

let GreenListing;

function initMapListing() {
    GreenListing = new GreenListing(mapData);
}